// extracted by mini-css-extract-plugin
module.exports = {"label":"MultiTextInput_diet_label__3Oygp","input":"MultiTextInput_diet_input__1YOho"};